import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon'
import { COLOR } from 'vars/color'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
} from '../Button.h'

export interface IInlinePlaySolidButtonProps extends IButtonProps {}

export const InlinePlaySolidButton = ({
  icon = IconNames.playSolid,
  iconSize = ButtonIconSizes.medium,
  corners = ButtonCorners.CORNERS_10,
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.Button1,
  fluid = ButtonFluid.None,
  ...rest
}: IInlinePlaySolidButtonProps): JSX.Element => {
  return (
    <Button
      icon={icon}
      iconSize={iconSize}
      corners={corners}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      {...rest}
    />
  )
}
